/*!
 * seq.js — seq(): stop a sound's sequence after its note, and start it again
 * © 2026 Rob Canning — GPLv3
 *
 *     seq(s, 0)          s finishes the note it is on and stops there: the
 *                        note dies away on its own envelope -- no cut, and
 *                        nothing left sustaining
 *     seq(s, 1)          on again from the next beat, its patterns going on
 *                        where they were
 *     seq([a, b], 0)     several; seq(all, 1) every one
 *
 * With env: beside envPerStep: (the whole sound's envelope), seq(s, 0) lets
 * the note sounding ring on, unreleased, dying away over env's r: -- no
 * note after it; seq(s, 1) swells it in over env's a:. Unlike gate(s, 0), the sequence does not run
 * on silent: it waits. hush() forgets it. Synths (synth.js does it).
 */

import { seqSynth } from "./synth.js";
import { levelArgs } from "./audio/level.js";
import { synthNames } from "./audio/voices.js";

/** seq(names, 1 | 0) as a cue. */
export function handleSeqCue(ast) {
  const a = levelArgs(ast?.args);
  if (!a.names.length) { console.warn("[seq] which sound? seq(s, 0) / seq(s, 1)"); return; }
  const on = Number(a.numbers[0] ?? 1) !== 0;
  for (const n of a.names.includes("all") ? synthNames() : a.names) seqSynth(n, on);
}
